import * as React from 'react';

export interface ISettingsCardProps {
  title: string;
  /** Optional supporting line under the title. */
  subtitle?: string;
  children: React.ReactNode;
}

/**
 * Settings card chrome with a static titled header (the "Personal Information"
 * style): a rounded, bordered card with a shaded header bar holding a title +
 * optional subtitle, and a padded body. For an expand/collapse header use
 * {@link CollapsibleSettingsCard} instead.
 */
const SettingsCard = ({ title, subtitle, children }: ISettingsCardProps) => (
  <div className="bg-primary border-secondary shadow-card overflow-hidden rounded-2xl border">
    <div className="bg-secondary border-secondary flex flex-col gap-0.5 border-b px-5 py-5">
      <p className="text-primary text-lg font-semibold">{title}</p>
      {subtitle && <p className="text-tertiary text-sm">{subtitle}</p>}
    </div>
    <div className="flex flex-col gap-8 px-5 py-6">{children}</div>
  </div>
);

SettingsCard.displayName = 'SettingsCard';

export default SettingsCard;
